(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9042],{

/***/ 15066:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]",
      function () {
        return __webpack_require__(21952);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _language_; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./ui/components/Hreflangs.tsx + 1 modules
var Hreflangs = __webpack_require__(5773);
// EXTERNAL MODULE: ./utils/regionBasedConstants.ts
var regionBasedConstants = __webpack_require__(97158);
;// CONCATENATED MODULE: ./utils/regionBasedWebsiteSchema.ts

function regionBasedWebsiteSchema(countryCode) {
    var country = regionBasedConstants/* REGION_INFO */.w[countryCode];
    if (!country) {
        return {};
    }
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "PUMA ".concat(country.name),
        alternateName: country.alternateName,
        url: country.url,
        potentialAction: {
            "@type": "SearchAction",
            target: "".concat(country.url, "search?q={search_term_string}"),
            "query-input": "required name=search_term_string"
        }
    };
}

// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 53 modules
var SanityContentSlot = __webpack_require__(2232);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(7676);
// EXTERNAL MODULE: ./groq/ContentSlots.ts
var ContentSlots = __webpack_require__(18273);
// EXTERNAL MODULE: ./groq/shared/LocaleSeo.ts + 1 modules
var LocaleSeo = __webpack_require__(16138);
;// CONCATENATED MODULE: ./groq/pages/HomePage.ts


var HomePageQuery = '\n  *[_id == "CategoryPage-" + upper($country) + "-root"][0] {\n    _id,\n    ...(category -> {\n      '.concat((0,LocaleSeo/* LocaleSeo */.U)("seo"), ',\n    }),\n    "slots": content[] ').concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ",\n    headersContent,\n  }\n");

// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var locale = __webpack_require__(79302);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./utils/regionBasedSchema.ts



function regionBasedSchema(countryCode) {
    var country = regionBasedConstants/* REGION_INFO */.w[countryCode];
    var countryBasedInfo = country ? {
        name: "PUMA ".concat(country.name),
        legalName: "".concat(country.legalName),
        logo: "".concat(country.logo),
        image: "".concat(country.image),
        url: "".concat(country.url),
        telephone: "".concat(country.telephone),
        address: {
            "@type": "PostalAddress",
            streetAddress: "".concat(country.streetAddress),
            addressLocality: "".concat(country.addressLocality),
            postalCode: "".concat(country.postalCode),
            addressCountry: "".concat(country.addressCountry)
        },
        contactPoint: [
            {
                "@type": "ContactPoint",
                telephone: "".concat(country.telephone),
                email: "".concat(country.email),
                areaServed: "".concat(country.areaServed),
                contactType: "customer service"
            }, 
        ]
    } : {};
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "http://schema.org",
        "@type": "Corporation",
        parentOrganization: {
            name: "PUMA",
            legalName: "PUMA SE",
            url: "https://www.puma.com/",
            numberofEmployees: "13000",
            address: {
                "@type": "PostalAddress",
                streetAddress: "PUMA WAY 1",
                addressLocality: "Herzogenaurach",
                postalCode: "91074",
                addressCountry: "DE"
            },
            founder: {
                "@type": "Person",
                name: "Rudolf Dassler",
                sameAs: [
                    "https://en.wikipedia.org/wiki/Rudolf_Dassler"
                ]
            },
            foundingLocation: {
                "@type": "Place",
                name: "Herzogenaurach, Germany",
                sameAs: [
                    "https://en.wikipedia.org/wiki/Herzogenaurach"
                ]
            },
            ethicsPolicy: "https://about.puma.com/en/sustainability/codes-and-handbooks",
            foundingDate: "1948-01-10",
            brand: {
                "@type": "Organization",
                name: "PUMA"
            }
        }
    }, countryBasedInfo), {
        brand: {
            "@type": "Organization",
            Name: "PUMA"
        },
        description: "PUMA is one of the world's leading sports brands, designing, developing, selling and marketing footwear, apparel and accessories. For over 65 years, PUMA has been producing the most innovative products for the fastest athletes on the planet. PUMA offers performance and sport-inspired lifestyle products in categories such as Football, Running and Training, Golf, and Motorsports. PUMA engages in exciting collaborations with renowned designers like STAPLE, STAMPD or TRAPSTAR to bring innovative and fast designs to the sports world. The PUMA Group owns the brands PUMA and COBRA Golf as well the subsidiary Dobotex. PUMA distributes its products in more than 120 countries and employs more than 13,000 people worldwide and is headquartered in Herzogenaurach/Germany.",
        sameAs: [
            "https://www.instagram.com/puma/",
            "https://www.instagram.com/pumasportstyle/",
            "https://x.com/puma",
            "https://www.linkedin.com/company/puma",
            "https://plus.google.com/+puma",
            "https://www.facebook.com/PUMA",
            "https://www.youtube.com/puma/",
            "https://en.wikipedia.org/wiki/Puma_(brand)",
            "https://www.crunchbase.com/organization/puma",
            "https://pumagroup.tumblr.com/",
            "https://about.puma.com/en",
            "https://www.reddit.com/r/PUMA/",
            "https://www.puma-catchup.com/",
            "https://www.youtube.com/user/puma",
            "https://www.wikidata.org/wiki/Q157064", 
        ]
    });
}

;// CONCATENATED MODULE: ./pages/[country]/[language]/index.tsx














var Home = function() {
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "HomePage",
        query: HomePageQuery
    }), 1), pageQuery = ref3[0];
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var mappedCountryCode = (0,locale/* getMappedCountryCode */.p5)(countryCode) || countryCode.toLowerCase();
    var page = (ref = pageQuery.data) === null || ref === void 0 ? void 0 : ref.content;
    var pageTitle = page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.pageTitle;
    var pageDescription = page === null || page === void 0 ? void 0 : (ref2 = page.seo) === null || ref2 === void 0 ? void 0 : ref2.pageDescription;
    var schema = regionBasedSchema(mappedCountryCode);
    var websiteSchema = regionBasedWebsiteSchema(mappedCountryCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageHead/* PageHead */.y, {
                title: pageTitle,
                description: pageDescription,
                noHreflangs: true,
                children: [
                    schema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify((0,object/* avoidEmptyProperties */._h)(schema))
                        }
                    }),
                    websiteSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify((0,object/* avoidEmptyProperties */._h)(websiteSchema))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hreflangs/* Hreflangs */.k, {
                id: "homepage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* Page */.T, {
                query: pageQuery,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                    items: page === null || page === void 0 ? void 0 : page.slots,
                    slotId: "slots",
                    documentId: page === null || page === void 0 ? void 0 : page._id,
                    fullscreen: true,
                    headersContent: page === null || page === void 0 ? void 0 : page.headersContent
                })
            })
        ]
    });
};
/* harmony default export */ var _language_ = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1489,9294,2042,6740,769,9774,2888,179], function() { return __webpack_exec__(15066); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);